export const mapUrlLocaleToOptimizelyCaseSensitiveLocale = (locale: string) => {
  if (locale.toLocaleLowerCase() === 'zh-cht') {
    return 'zh-CHT';
  }

  if (locale.toLocaleLowerCase() === 'zh-cn') {
    return 'zh-CN';
  }

  return locale;
};
